<template>
      <v-card class="ma-4">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text class="pa-0">
          <v-overlay absolute v-if="loading">
            <v-progress-circular
              indeterminate
              :size="50"
              :width="5"
              color="primary"
            >
            </v-progress-circular>
          </v-overlay>

          <v-row class="mx-1 mt-2 pa-2 mb-0 pb-0" no-gutters>
            <v-col cols="2" class="pr-2">
              <DatePickerISOCompliant
                :label="$t('From')"
                v-model="filter.from"
                @change="changeFilter"
                required
                :rules="fromDateRules"
                dense
              />
            </v-col>
            <v-col cols="2" class="pr-2">
              <DatePickerISOCompliant
                :label="$t('To')"
                v-model="filter.to"
                @change="changeFilter"
                clearable
                dense
              />
            </v-col>
            <v-col cols="2" class="pr-2">
              <BaseTimePicker
                v-model="filter.timeFrom"
                :label="$t('Site.Management.TimeFrom')"
                v-if="timeFrom"
                @change="changeFilter"
                clearable
                dense
              />
            </v-col>
            <v-col cols="2" class="pr-2">
              <BaseTimePicker
                v-model="filter.timeTo"
                :label="$t('Site.Management.TimeTo')"
                v-if="timeTo"
                @change="changeFilter"
                clearable
                dense
              />
            </v-col>
            <v-col cols="2" class="pr-2">
              <v-text-field
                v-model="filter.message"
                :label="$t('Site.Management.SearchableValues') + '...'"
                prepend-inner-icon="mdi-magnify"
                v-debounce:600ms="changeFilter"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-autocomplete
                v-model="filter.activity"
                prepend-inner-icon="mdi-pulse"
                :items="listActivity"
                :item-text="item => $t('Site.' + item.text)"
                :label="$t('Site.Management.Activity')"
                @change="changeFilter"
                clearable
                multiple
                dense
              ></v-autocomplete>
            </v-col>
          </v-row>

          <div class="text-center blue-grey lighten-4 py-1" v-if="selectAll">
            {{ $t("Selected") }}: {{ selectedItemCount() }} {{ $t("Documents") }}
          </div>

          <v-simple-table dense>
            <thead>
              <tr>
                <th class="text-left">
                  <v-checkbox
                    v-model="selectAll"
                    @change="selectAllItemsInPage"
                    dense
                  ></v-checkbox>
                </th>
                <th class="text-left" @click="onTableHeadClicked('ActivityDate')">
                  <h4 href="javascript:void(0)" style="cursor: pointer">
                    {{ this.$t("Site.Management.DateOfRegistry") }}
                    <span
                      v-if="
                        'ActivityDate' === paginationSetting.orderBy.split(':')[0] &&
                        !paginationSetting.desc
                      "
                      >↓</span
                    >
                    <span
                      v-if="
                        'ActivityDate' === paginationSetting.orderBy.split(':')[0] &&
                        paginationSetting.desc
                      "
                      >↑</span
                    >
                  </h4>
                </th>
                <th class="text-left">
                  <h4>
                    {{ this.$t("Site.Management.Message") }}
                  </h4>
                </th>
                <th class="text-left" @click="onTableHeadClicked('ActivityCategory')">
                  <h4 style="cursor: pointer">
                    {{ this.$t("Site.Management.Activity") }}
                    <span
                      v-if="
                        'ActivityCategory' === paginationSetting.orderBy.split(':')[0] &&
                        !paginationSetting.desc
                      "
                      >↓</span
                    >
                    <span
                      v-if="
                        'ActivityCategory' === paginationSetting.orderBy.split(':')[0] &&
                        paginationSetting.desc
                      "
                      >↑</span
                    >
                  </h4>
                </th>
                <th class="text-left">
                  <h4>
                    {{ this.$t("Site.Management.SearchableValues") }}
                  </h4>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="dataSource.length === 0">
                <td colspan="9999" class="text-center table-no-data">{{ this.$t("NoData") }}</td>
              </tr>
              <tr
                v-for="(column, index) in dataSource"
                :key="index"
                @click="toggleRowSelect(column)"
              >
                <td>
                  <v-checkbox
                    v-model="column.IsSelected"
                    @change="selectThisItem"
                    dense
                    hide-details
                    class="mt-0"
                    @click.stop
                  ></v-checkbox>
                </td>
                <td>{{ convertTimeToFormatUser(column.activityDate) }}</td>
                <td>{{ getTranslationOfMessage(column) }}</td>
                <td>{{ getEventName(column.activityCategory) }}</td>
                <td>{{ getSearchableValues(column) }}</td>
              </tr>
            </tbody>
          </v-simple-table>

          <PaginationComponent
            :ref="paginationComponentKey"
            :totalPages="totalPages"
            :totalItems="totalItems"
            @on-page-change="getData"
          >
          </PaginationComponent>
        </v-card-text>
      </v-card>
</template>

<script>
import PaginationSetting from '../../../ecm/models/PaginationSetting';
import PaginationComponent from '@/components/base/PaginationComponent.vue';
import ActivityRegistryService from '@/services/ActivityRegistryService';
import DatePickerISOCompliant from '@/components/base/DatePickerISOCompliant';
import Utils from '@/ecm/common/Utils.js';
import ActivityUtils from '@/ecm/common/ActivityUtils.js';
import ActivityCategory from '@/ecm/variables/ActivityCategory';
export default {
    components: {
        PaginationComponent,
        DatePickerISOCompliant
    },
    data() {
        return {
            restoreLoading: false,
            title: this.$t('RegistrationActivity'),
            dataSource: [],
            paginationSetting: new PaginationSetting(),
            loading: false,
            totalPages: 1,
            paginationComponentKey: 'paginationComponentKey',
            totalItems: 1,
            selectAll: false,
            isModalOpen: false,
            modalData: {
                fields: [],
            },
            listActivity: [],
            filter: {
                from: null,
                timeFrom: null,
                to: null,
                timeTo: null,
                event: null,
                message: null,
            },
            timeFrom: true,
            timeTo: true,
            fromDateRules: [v => !!v || this.$t('Required')]
        };
    },
    created() {
        this.$nextTick(() => {
            this.paginationComponentInstance.reset(true);
            this.listActivity = ActivityUtils.activitiesList;
        });
        this.filter.from = new Date().toISOString().split('T')[0];
        this.filter.timeFrom = '00:00';
    },
    computed: {
        paginationComponentInstance() {
            return this.$refs[this.paginationComponentKey];
        },
    },
    methods: {
        getData(paginationOptions) {
            if (!this.filter.from)
                return;
            this.loading = true;

            if (this.paginationSetting.page > this.totalPages) {
                this.paginationSetting.page = this.totalPages;
            }
            if (paginationOptions && paginationOptions.page) {
                this.paginationSetting.page = paginationOptions.page;
            }
            if (paginationOptions && paginationOptions.pageSize)
                this.paginationSetting.pageSize = paginationOptions.pageSize;

            const today = new Date().toISOString().split('T')[0];

            const dateTimeFrom = Utils.date.addTimeZoneFromIsoFormat(
                `${this.filter.from || today}T${this.filter.timeFrom || '00:00'}:00`
            );

            const dateTimeTo = Utils.date.addTimeZoneFromIsoFormat(
                `${this.filter.to || today}T${this.filter.timeTo || '23:59'}:00`
            );

            ActivityRegistryService.getList(dateTimeFrom, dateTimeTo, this.paginationSetting.orderBy || 'ActivityDate:desc', this.filter.activity || [], this.filter.message, this.paginationSetting.page, this.paginationSetting.pageSize)
                .then((data) => {
                    this.totalPages = Math.ceil(data.totalCount / this.paginationSetting.pageSize);
                    if (this.totalPages === 0)
                        this.totalPages = 1;
                    this.totalItems = data.totalCount;
                    this.dataSource = data.registries;

                    if (this.dataSource.length === 0 && this.paginationSetting.page > 1) {
                        // If it's empty, go back to the previous page
                        this.$refs.paginationComponentKey.changePage(this.paginationSetting.page - 1);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        onTableHeadClicked(column) {
            const orderBy = this.paginationSetting.orderBy.split(':')[0];

            if (
                orderBy !== column ||
                this.paginationSetting.orderBy === ''
            ) {
                this.paginationSetting.desc = false;
            } else {
                this.paginationSetting.desc = !this.paginationSetting.desc;
            }

            this.paginationSetting.orderBy = `${column}:${this.paginationSetting.desc ? 'desc' : 'asc'}`;
            this.getData();
        },
        getTranslationOfMessage(column) {
            if (!column.valuesToReplace || !Array.isArray(column.valuesToReplace)) {
                return this.$t(`Site.ActivityMessages.${column.messageKey}`);
            }
            let translatedText = this.$t(`Site.ActivityMessages.${column.messageKey}`);
            column.valuesToReplace.forEach((value, index) => {
                const placeholder = `{${index}}`;
                translatedText = translatedText.replace(placeholder, value);
            });
            return translatedText;
        },
        convertTimeToFormatUser(date) {
            return Utils.date.toUserFormatFromIso(date);
        },
        getEventName(activityCategory) {
            return this.$t(`Site.Management.${ActivityCategory[activityCategory]}`);
        },
        selectAllItemsInPage() {
            this.dataSource.forEach(
                (element) => (element.IsSelected = this.selectAll)
            );
        },
        selectThisItem() {
            this.selectAll = this.dataSource.every((element) => element.IsSelected);
        },
        selectedItemCount() {
            return this.dataSource.filter((x) => x.IsSelected).length;
        },
        selectEveryItem() {
            this.ignorePagingOnDelete = true;
        },
        toggleRowSelect(column) {
            column.IsSelected = !column.IsSelected;
            this.$forceUpdate();
            this.selectAll = this.dataSource.every((element) => element.IsSelected);
        },
        changeFilter() {
            this.paginationComponentInstance.reset();
        },
        getSearchableValues(column) {
            if (!column.valuesToReplace || !Array.isArray(column.valuesToReplace)) {
                return this.$t(column.messageKey);
            }
            const searchableValues = column.valuesToReplace.filter((x) => x !== '' && x !== null && x !== undefined);
            return searchableValues.join(', ');
        },
    },
};
</script>
